import React from "react";

import { firebase } from "astrid-firebase";
import createSerieData from "astrid-firestore/src/api/series/createSerieData";

import Form from "../../../forms/components/Form/Form";

export default function ArticleMetaDataSerieSelect({ name, publisher, disabled }) {
	const { watch } = Form.useFormContext();

	const serie = watch(name);

	return (
		<Form.InstantSearchSelect
			disabled={disabled}
			name={name}
			search
			allowEmpty
			allowAdditions
			indexName="series"
			filters={`publisher.id:${publisher?.id}`}
			getOption={(serie) => ({
				key: serie.id,
				text: serie.name,
				value: serie.id,
				data: serie,
			})}
			onAddDocument={(name) => {
				return createSerieData(firebase, { name, publisher });
			}}
			getMissingOption={(option) => ({ ...option, text: serie?.name })}
		/>
	);
}
